import { render, staticRenderFns } from "./base-flickity.vue?vue&type=template&id=1d2dc2b2&scoped=true&"
import script from "./base-flickity.vue?vue&type=script&lang=js&"
export * from "./base-flickity.vue?vue&type=script&lang=js&"
import style0 from "./base-flickity.vue?vue&type=style&index=0&id=1d2dc2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2dc2b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2dc2b2')) {
      api.createRecord('1d2dc2b2', component.options)
    } else {
      api.reload('1d2dc2b2', component.options)
    }
    module.hot.accept("./base-flickity.vue?vue&type=template&id=1d2dc2b2&scoped=true&", function () {
      api.rerender('1d2dc2b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/base-flickity.vue"
export default component.exports